import React, { useEffect } from 'react';
import {
    Box,
    Container,
    Heading,
    Text,
    VStack,
    Button,
    Spinner
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const CheckoutReturn = ({ ...props }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const queryParams = new URLSearchParams(location.search);
    const paymentIntent = queryParams.get('payment_intent') || '';
    const redirectStatus = queryParams.get('redirect_status') || '';

    useEffect(() => {
        if (redirectStatus === 'succeeded') {
            setTimeout(() => {
                navigate(`/CheckoutResult?payment_intent=${paymentIntent}&redirect_status=succeeded`);
            }, 2000);
        } else if (redirectStatus === 'failed') {
            setTimeout(() => {
                navigate(`/CheckoutResult?payment_intent=${paymentIntent}&redirect_status=failed`);
            }, 2000);
        }
    }, []);

    return (
        <Box
            minH="calc(100vh - 64px)"
            bg="canvas"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <Container maxW="400px" px={4}>
                <Box
                    p={10}
                    borderRadius="xl"
                    bg="surfaceCard"
                    border="1px solid"
                    borderColor="hairline"
                    textAlign="center"
                >
                    <VStack spacing={6}>
                        <Spinner size="xl" color="brand.primary" thickness="4px" />
                        <Heading size="lg" color="ink">
                            {t('checkout.processing_payment')}
                        </Heading>
                        <Text color="muted" fontSize="sm">
                            {t('checkout.processing_payment_description')}
                        </Text>
                    </VStack>
                </Box>
            </Container>
        </Box>
    );
};

export default CheckoutReturn;